commonAlphabet